import React, { useState, useEffect } from "react";
import "./notificationAdd.scss";
import { Typography, Button, Form, Input, Select, DatePicker, Checkbox, Card } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import Pageloader from "../../../../components/loader";
import { validationErrors } from "../../../../utils/Helpers";
import { useNavigate } from "react-router-dom";
import RichTextEditor from "../../../../components/richTextEditor/richTextEditor";
import * as notificationAction from "../../../../redux/actions/notification.actions";
import * as zoneActions from "../../../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title } = Typography;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const pageLink = "notification";

const NotificationAdd = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [richTextEditor, setRichTextEditor] = useState('');
  const [nameOption, setnameOption] = useState({
    cityOption: [
      {value: 'Karachi', label: 'Karachi'},
      {value: 'Lahore', label: 'Lahore'},
      {value: 'Rawalpindi', label: 'Rawalpindi'},
      {value: 'Islamabad', label: 'Islamabad'},
    ],
    batchOption: [
      {value: '1', label: '1'},
      {value: '2', label: '2'},
      {value: '3', label: '3'},
      {value: '4', label: '4'},
      {value: '5', label: '5'},
      {value: '6', label: '6'},
    ],
    riderOption: [
      {value: 'active', label: 'Active'},
      {value: 'inactive', label: 'Inactive'},
    ],
  });

  useEffect(() => {
      postLists()
  }, [])

  const postLists = async () => {
    const pageData = {
      page: 1,
      limit: 50,
    };
    try {
      setLoading(true);
      await props.notificationAction.getCategoriesAction(pageData)
      await props.zoneActions.getZoneListAction();
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.categoriesData){postDataOptionConvert(props?.categoriesData, "id", "title", "categoryOption")}
  }, [props.categoriesData]);

  useEffect(() => {
    // console.log("props.zoneData", props.zoneData)
    if (props.zoneData){postDataOptionConvert(props?.zoneData, "storeId", "zoneName", "zoneOption")}
  }, [props.zoneData]);

  const postDataOptionConvert = async (data, keyValue, keylabel, optionName) => {
    const dataoption = [];
    try {
      data && data.map((item)=>{
        if (item.length !== 0) {dataoption.push({value: item[keyValue] , label: item[keylabel]})}
      })
      setnameOption((nameOption)=>({
        ...nameOption,
        [optionName]: dataoption,
      }))
    } catch {}
  }

  const onFinish = async (values) => {
    let dataFix ={
      ...values,
      content: (richTextEditor||"")
    }
    // console.log("dataFix", dataFix)
    // return null
    try {
      setLoading(true);
      await props.notificationAction.postNotificationAction(dataFix)
      navigate(`/${pageLink}`)
    } catch (e) { validationErrors(e) } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>Notification Add</Title>
        <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
      </div>
      <div className="p-content">
        {loading ? <Pageloader />:
        <Form onFinish={onFinish} layout="vertical">
          <div className="page-list ffr aifs">
            <Form.Item
              name={["date"]}
              label={"Date"}
              rules={[{required: true, message: "Please Select value"}]}
            >
              <RangePicker
                allowClear
                format="YYYY-MM-DD"
                disabled={props.loading}
                />
            </Form.Item>
            <Form.Item
              name={["city"]}
              label={"City"}
              rules={[{required: true, message: "Please Select value"}]}
            >
              <Select
                style={{minWidth:"150px"}}
                mode="multiple"
                showSearch
                placeholder="Select Option"
                optionFilterProp="children"
                filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={nameOption?.cityOption}
              />
            </Form.Item>
            <Form.Item
              name={["store"]}
              label={"Mart"}
              // rules={[{required: true, message: "Please enter value"}]}
            >
              <Select
                style={{minWidth:"300px"}}
                mode="multiple"
                showSearch
                placeholder="Select Option"
                optionFilterProp="children"
                filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={nameOption?.zoneOption}
              />
            </Form.Item>
            <Form.Item
              name={["batch"]}
              label={"Batch"}
              // rules={[{required: true, message: "Please enter value"}]}
            >
              <Select
                style={{minWidth:"150px"}}
                mode="multiple"
                showSearch
                placeholder="Select Option"
                optionFilterProp="children"
                filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={nameOption?.batchOption}
              />
            </Form.Item>
            {/* <Form.Item
              name={["rider"]}
              label={"Rider"}
            >
              <Select
                style={{minWidth:"150px"}}
                mode="multiple"
                showSearch
                placeholder="Select Option"
                optionFilterProp="children"
                filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                options={nameOption?.riderOption}
              />
            </Form.Item> */}
          </div>
          <div className="page-list ffr aifs">
            <Form.Item
              name={["category"]}
              label={"Choose Category"}
              rules={[{required: true, message: "Please enter value"}]}
            >
              <Checkbox.Group className="page-list ffc aifs" options={nameOption?.categoryOption} />
            </Form.Item>
              <Card className="page-list ffc aifs notificationCard">
                <Form.Item
                  name={["title"]}
                  label={"Notification heading"}
                  rules={[{required: true, message: "Please enter value"}]}
                >
                  <Input/>
                </Form.Item>
                <Form.Item
                  name={["description"]}
                  label={"Write your message here"}
                  rules={[{required: true, message: "Please enter value"}]}
                >
                  <TextArea rows={4} />
                </Form.Item>
                <Form.Item
                  // name={["message"]}
                  label={"content"}
                  rules={[{required: true, message: "Please enter value"}]}
                >
                  <RichTextEditor textdata={richTextEditor} returndata={setRichTextEditor}/>
                </Form.Item>
              </Card>
          </div>

          <Button className="submit mt-15" htmlType="submit">Send</Button>
        </Form>
        }
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    categoriesData: state.NotificationReducer.categoriesData,
    zoneData: state.ZoneReducer.zoneData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    notificationAction: bindActionCreators(notificationAction, dispatch),
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationAdd);